import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Button from "@material-ui/core/Button"
import { FaWhatsapp } from "react-icons/fa"
const useStyles = makeStyles(theme => ({
  Button: {
    borderRadius: props => (props.disableRadius ? 0 : theme.spacing(3)),
    margin: props => (props.disableRadius ? 0 : theme.spacing(1)),
    background: props =>
      props.secondary
        ? theme.palette.secondary.main
        : props.bland
        ? "transparent"
        : theme.palette.text.primary,
    color: props =>
      props.secondary || props.bland
        ? theme.palette.text.primary
        : theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
    },
  },
}))
export default ({
  children,
  whatsapp,
  secondary,
  bland,
  disableRadius,
  fullwidth,
  component,
  to,
  href,
  target,
  rel,
  aria_label,
}) => {
  const classes = useStyles({ secondary, bland, disableRadius })
  return (
    <Button
      fullWidth={fullwidth && fullwidth}
      startIcon={whatsapp && <FaWhatsapp />}
      variant="contained"
      size="large"
      className={classes.Button}
      component={component && component}
      to={to && to}
      href={href && href}
      target={target && target}
      rel={rel && rel}
      aria-label={aria_label && aria_label}
      underline="none"
    >
      {children}
    </Button>
  )
}
